import { BaseService, type ResponseMessage } from "@kiddocare-platform/portal-common/base";
import type { Channel } from "@kiddocare-platform/portal-common/communication";
import type { Instance, Partecipant } from "@kiddocare-platform/portal-common/core";

export class CommunicationCallsService extends BaseService {

  public async GetChannel(token: string): Promise<ResponseMessage<{
    channel?: Channel,
    instance?: Instance,
    partecipants: Array<Partecipant>
  }>> {
    try {
      const response = await this.AxiosInstance.get(`/parent/calls/getChannel/${token}`);
      return response.data;
    } catch (error: any) {
      this.log.error("GetChannel", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async RejectCall(ticket: string): Promise<ResponseMessage<unknown>> {
    try {
      const response = await this.AxiosInstance.post(`/parent/calls/rejectCall/${ticket}`);
      return response.data;
    } catch (error: any) {
      this.log.error("RejectCall", error.stack, JSON.stringify(error));
      throw error;
    }
  }

}